<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="1100px" center :close-on-click-modal="false" @close="dialogClose">
    <div class="add">
      <div class="baseInfo">
        <div class="baseInfoContent">
          <div-border label="发票信息" prop="plan">
            <el-form :model="form" label-width="110px" label-position="right" :rules="rules" ref="addForm" class="demo-addForm">
              <div class="yang" v-for="(item, index) in form.formData" :key="index">
                <el-row>
                  <el-col :span="24">
                    <i v-show="form.formData.length > 1" class="el-icon-error pointer right" @click="removeInvoice(index)" />
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="发票号码：" :rules="rules.invoiceNo" :prop="`formData.${index}.invoiceNo`">
                      <el-input v-model="item.invoiceNo" :disabled="dialogTitle === '详情'" placeholder="请输入发票号码" type="number" size="mini" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="发票代码：" :rules="rules.invoiceCode" :prop="`formData.${index}.invoiceCode`">
                      <el-input v-model="item.invoiceCode" :disabled="dialogTitle === '详情'" placeholder="请输入发票代码" type="text" size="mini" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="发票日期：" :rules="rules.invoicDate" :prop="`formData.${index}.invoicDate`">
                      <el-date-picker :disabled="dialogTitle === '详情'" v-model="item.invoicDate" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="请选择发票日期" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="含税金额：" :rules="rules.taxPrice" :prop="`formData.${index}.taxPrice`">
                      <el-input v-model="item.taxPrice" :disabled="dialogTitle === '详情'" placeholder="请输入含税金额" @change="handleChangeTaxPrice($event, index)" type="number" size="mini" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="$route.path != '/settle/supplierDeductionExpenses'">
                    <el-form-item label="不含税金额：" :rules="rules.price" :prop="`formData.${index}.price`">
                      <el-input v-model="item.price" :disabled="dialogTitle === '详情'" placeholder="请输入不含税金额" type="number" size="mini" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="$route.path != '/settle/supplierDeductionExpenses'">
                    <el-form-item label="税率：" :rules="rules.taxRate" :prop="`formData.${index}.taxRate`">
                      <el-input v-model="item.taxRate" placeholder="请输入税率" @input="priceFormat($event, index)" size="mini">
                        <template slot="append">%</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="备注：">
                      <el-input v-model="item.remark" :disabled="dialogTitle === '详情'" :autosize="remarkObj" type="textarea" placeholder="请输入备注" size="mini" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-form>
            <div v-if="dialogTitle === '填写发票信息'" class="teamAdd">
              <span>添加发票：</span>
              <div class="add" @click="addInvoice">+</div>
            </div>
          </div-border>
          <div class="btnContainer" v-if="dialogTitle !== '详情'">
            <el-button size="medium" class="searchBtn" :loading="loading" @click="submit"> 确定 </el-button>
            <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import divBorder from '@/components/divBorder.vue';
  import { addInvoiceManually } from '@/service/getData';

  export default {
    name: 'invoiceInformation',
    components: { divBorder },
    data() {
      return {
        taxRate: '',
        dialogTitle: '填写发票信息',
        dialogVisible: false,
        basicId: '',
        form: {
          formData: [
            {
              invoiceNo: '', // 发票号码
              invoiceCode: '', // 发票代码
              invoicDate: '', // 发票日期
              taxPrice: '', // 含税金额
              price: '', // 不含税金额
              taxRate: '', // 税率
              remark: '', // 备注
              reconciliator: '',
            },
          ],
        },
        formData: {
          invoiceNo: '', // 发票号码
          invoiceCode: '', // 发票代码
          invoicDate: '', // 发票日期
          taxPrice: '', // 含税金额
          price: '', // 不含税金额
          taxRate: '', // 税率
          remark: '', // 备注
          reconciliator: '',
          // taxRate: '',
        },
        rules: {
          invoiceNo: [
            {
              required: true,
              message: '请输入发票号码',
              trigger: 'blur',
            },
          ],
          invoiceCode: [
            {
              required: true,
              message: '请输入发票代码',
              trigger: 'blur',
            },
          ],
          invoicDate: [
            {
              required: true,
              message: '请选择发票日期',
              trigger: 'blur',
            },
          ],
          taxPrice: [
            {
              required: true,
              message: '请输入含税金额',
              trigger: 'blur',
            },
          ],
          price: [
            {
              required: true,
              message: '请输入不含税金额',
              trigger: 'blur',
            },
          ],
          taxRate: [
            {
              required: true,
              message: '请输入税率',
              trigger: 'blur',
            },
          ],
        },
        loading: false,
        remarkObj: {
          minRows: 4,
          maxRows: 8,
        },
      };
    },
    methods: {
      handleChangeTaxPrice(value, index) {
        const pricei = Number(String(value/(1+this.form.formData[index]['taxRate']*0.01)));
        this.form.formData[index]['price'] = pricei.toFixed(2)
      },
      // 打开弹出框
      openDialog(id, reconciliator) {
        this.dialogVisible = true;
        this.basicId = id;
        this.formData.reconciliator = reconciliator;
      },
      // 设置税率
      setTaxRate(val) {
        this.taxRate = val;
        this.form.formData[0]['taxRate'] = val;
        this.formData['taxRate'] = val;
      },
      // 关闭弹出框
      dialogClose() {
        this.dialogVisible = false;
        this.form.formData = [];
        // console.log(this.formData);
        // console.log(JSON.parse(JSON.stringify(this.formData)));
        this.form.formData.push(JSON.parse(JSON.stringify(this.formData)));
        // console.log(this.form.formData);
        this.$emit('getList');
      },
      // 提交
      async submit() {
        await this.$refs.addForm.validate(async valid => {
          if (valid) {
            // 调用接口
            const { status, message } = await addInvoiceManually({
              id: this.basicId,
              invoiceManageList: this.form.formData,
              reconciliator: this.formData.reconciliator,
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.dialogClose();
          } else {
            return false;
          }
        });
      },
      // 价格 format
      priceFormat(e, index) {
        console.log(e);
        let value = e.replace(/[^\d]/g, ''); // 以0开头或者输入非数字，会被替换成空
        if (value.length > 2) value = value.slice(0, 2);
        this.form.formData[index].taxRate = value;
      },
      // 新增发票
      addInvoice() {
        let flag = false;
        if (this.form.formData && this.form.formData.length > 0) {
          this.form.formData.forEach(res => {
            console.log(res);
            for (const resKey in res) {
              if (resKey === 'remark' || resKey === 'reconciliator') continue;
              if (!res[resKey] || res[resKey] === '') flag = true;
            }
          });
        }
        if (flag) {
          return this.$message.warning('请填写完当前发票信息后新增发票！');
        }
        // this.formData['taxRate'] = this.taxRate;
        this.form.formData.push(JSON.parse(JSON.stringify(this.formData)));
      },
      // 删除
      removeInvoice(index) {
        this.$confirm('确定要删除当前发票吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (this.form.formData.length && this.form.formData.length > 1) this.form.formData.splice(index, 1);
          })
          .catch();
      },
    },
    mounted() {
      // console.log('<<<');
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep .add {
    .el-form-item__label {
      font-weight: 700;
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    width: 100%;

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;
        font-size: 14px;

        .center-f {
          display: flex;
        }

        .yang {
          margin-top: 10px;
          border-bottom: 1px solid #cbcbcb;

          .el-form-item {
            margin-bottom: 15px;

            .el-form-item__label {
              //width: 150px !important;
              /*color: #060606;*/
            }

            .el-input {
              width: 100%;
            }

            .el-textarea {
              width: 100%;
            }
          }
        }

        .el-upload-list__item {
          width: 100px;
          height: 100px;
        }

        .el-upload--picture-card {
          width: 100px;
          height: 100px;
          line-height: 100px;
        }

        .imgUp {
          display: flex;
          flex-direction: column;

          .imgLength {
            display: flex;
            align-items: center;
            width: 100%;

            span {
              margin-left: auto;
              color: rgb(183, 183, 183);
              font-size: 16px;
            }
          }
        }
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 13px;
      margin-top: 20px;

      button {
        margin: 0 15px;
      }
    }
  }

  .el-form-item__content .el-input-group {
    vertical-align: middle;
  }

  .team {
    &Add {
      display: flex;
      align-items: center;
      margin: 20px 0;

      .add {
        width: 20px;
        height: 20px;
        padding-bottom: 3px;
        background-color: #999;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        margin-right: 15px;

        &:hover {
          cursor: pointer;
        }
      }

      span {
        font-size: 14px;
        color: #606266;
        font-weight: 700;
      }
    }

    &Item {
      display: flex;
      align-items: center;
      color: #999;
      font-size: 14px;
      margin-top: 10px;
      padding-bottom: 10px;

      span {
        margin-left: 5px;
        color: #606266;
        font-weight: 700;
      }

      border-bottom: 1px solid #cbcbcb;
    }
  }
</style>
